import { render } from "./loader.inline.vue?vue&type=template&id=03ffd792"
import script from "./loader.inline.vue?vue&type=script&lang=js"
export * from "./loader.inline.vue?vue&type=script&lang=js"

import "./loader.inline.vue?vue&type=style&index=0&id=03ffd792&lang=css"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__